import type { SystemSettings } from '@/configuration/ConfigurationTypes';

const cacheKey = 'entity_portal_system_settings_cache';

function safeParse(value: string): SystemSettings | null {
  try {
    return JSON.parse(value) as SystemSettings;
  } catch {
    return null;
  }
}

export const configurationCache = {
  read(): SystemSettings | null {
    const value = window.localStorage.getItem(cacheKey);

    if (!value) {
      return null;
    }

    return safeParse(value);
  },

  write(settings: SystemSettings): void {
    window.localStorage.setItem(cacheKey, JSON.stringify(settings));
  },

  clear(): void {
    window.localStorage.removeItem(cacheKey);
  },
};
